'use client';

import { useViewport } from '@lib/tools/hooks/useViewport';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import style from './LoaderCircle.module.scss';

const LoaderCircle = ({ isLoading, someStyles }) => {
  const { viewport } = useViewport();
  const [isAppleDevice, setIsAppleDevice] = useState(false);

  useEffect(() => {
    setIsAppleDevice(/(iPad|iPhone|Mac)/i.test(window.navigator.userAgent));
  }, []);

  if (!viewport) return undefined;

  return (
    <div className={classNames(style.nl_reploader_father, { [style.__hide]: isLoading }, someStyles)}>
      <div className={style.nl_preloader}>
        <span className={isAppleDevice ? style.loaderApple : style.loader} />
      </div>
    </div>
  );
};

export default LoaderCircle;
